import script from "./ReminderMailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReminderMailModal.vue?vue&type=script&lang=ts&setup=true"

import "./ReminderMailModal.vue?vue&type=style&index=0&id=d3197128&lang=scss&scoped=true"
import "./ReminderMailModal.vue?vue&type=style&index=1&id=d3197128&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3197128"]])

export default __exports__